import {getMethod} from '~/api'

async function get(request) {
    return await getMethod('/api/salesSettings', request)
}

export {get}
